module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.total > 0) ? _c('nav', {
    attrs: {
      "aria-label": "Page navigation"
    }
  }, [_c('ul', {
    staticClass: "pagination justify-content-center"
  }, [_c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!(_vm.current <= 1)),
      expression: "!(current <= 1)"
    }],
    staticClass: "page-item",
    class: {
      disabled: _vm.current <= 1
    }
  }, [_c('a', {
    staticClass: "page-link border-primary text-primary",
    on: {
      "click": function($event) {
        return _vm.go(_vm.current - 1)
      }
    }
  }, [_vm._v("<")])]), _vm._v(" "), _vm._l((_vm.range), function(page) {
    return _c('li', {
      staticClass: "page-item",
      class: {
        active: page === _vm.current
      }
    }, [_c('a', {
      staticClass: "page-link border-primary text-primary",
      on: {
        "click": function($event) {
          return _vm.go(page)
        }
      }
    }, [_vm._v(_vm._s((page >= 10) ? page : '0' + page))])])
  }), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!(_vm.current >= _vm.total)),
      expression: "!(current >= total)"
    }],
    staticClass: "page-item",
    class: {
      disabled: _vm.current >= _vm.total
    }
  }, [_c('a', {
    staticClass: "page-link border-primary text-primary",
    on: {
      "click": function($event) {
        return _vm.go(_vm.current + 1)
      }
    }
  }, [_vm._v(">")])])], 2)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2169f883!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pagination.vue
// module id = 761
// module chunks = 3